import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-242f2a82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "addition" }
const _hoisted_2 = { class: "rel" }
const _hoisted_3 = {
  key: 1,
  class: "title ft-w-6 flex pt_10 mr_20 pb_20",
  style: {"font-size":"16px"}
}
const _hoisted_4 = {
  class: "abs clear-add",
  style: {"right":"-11px","top":"-6px"}
}
const _hoisted_5 = { class: "text-rt mt_10 commit submit-btn" }
const _hoisted_6 = {
  key: 0,
  class: "primary mtrl-tip",
  style: {"font-size":"12px","line-height":"18px"}
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "btn-content" }

import { ref, computed, watch } from 'vue'
import AdtLoop from './components/AdtLoop.vue'
import AdtList from './components/AdtList.vue'
import AdtCate from './components/AdtCate.vue'
import AdtMtrl from './components/AdtMtrl.vue'
import AdtTemplate from './components/AdtTemplate.vue'
import store, { getWarehouseCode } from '@/store'
import { t } from '@/plugins/i18n'
import { useRequest } from '@/util/useLoading'
import { addAdtCfg, updateAdtCfg } from '@/apis/setup'
import useEdited from '@/util/useEdited'
import { confirmEdit as confirm } from '@/util/useConfirm'
import { ElMessage } from 'element-plus'
import { adt } from '@/util/useData'
import { useWrap } from '@/util/useCheckMap'
import useUtil from './index'
import { COUNTRY } from '@/global'

export default /*#__PURE__*/_defineComponent({
  props: ['forCate', 'cfg', 'hasMap', 'additionScene', 'countryCode', 'choiceCost'],
  emits: ['beforeClose', 'update'],
  async setup(__props, { expose, emit }) {

let __temp: any, __restore: any

const props = __props
const isLogin = computed(() => store.getters.isLogin)

const {
  additionSort,
  sortAdd,
  scrollView
} = useUtil()

// countryCode 国家 CN KR

// 选中的附加项Map
const [adtMap, wrap] = useWrap(
  props.cfg?.additionItemList ?? [],
  'additionId'
)
const refMap: any = {}
const adtRes: any = ref([])
const warehouseCode = getWarehouseCode(props.countryCode === 'KR')
adtRes.value = (
  ([__temp,__restore] = _withAsyncContext(() => adt(warehouseCode).then((data) => {
  return data.productAdditionList.map((v: any) => {
    const t = { ...v }
    if (adtMap[t.additionId]) {
      // 附加项列表添加已配置的辅料sku
      t.ingredientsSku = adtMap[t.additionId].ingredientsSku
      // 原始数据源
      adtMap[t.additionId] = JSON.parse(JSON.stringify({
        ...t,
        ...adtMap[t.additionId]
      }))
      // 关联附加项列表
      refMap[t.additionId] = t
    }
    // 抽检回显
    if (t.spotCheckSupport === 1) {
      t.spotCheckFlag = adtMap[t.additionId]?.spotCheckFlag && adtMap[t.additionId].spotCheckRatio ? 1 : 0
      t.spotCheckRatio = adtMap[t.additionId]?.spotCheckRatio || ''
    }
    // 返回重新生成的附加项列表
    return t
  })
}))),
  __temp = await __temp,
  __restore(),
  __temp
)

const cates = ref(props.cfg?.categoryAdditionList)


const hasMap = computed(() => {
  // 新生成一个has，并去除当前配置下的类目
  const has = { ...props.hasMap }
  if (cates.value) {
    cates.value.forEach((v: any) => {
      delete has[v.categoryCateId]
    })
  }
  return has
})

let cateMap = {}
const cateList: any = []
if (props.cfg) {
  if (props.forCate) {
    cateMap = cates.value.reduce((acc: any, v: any) => {
      acc[v.categoryCateId] = true
      cateList.push(Number(v.categoryCateId))
      return acc
    }, {})
  }
}

const visible = ref(true)

const [loading, api] = useRequest((data: any) => {
  if (props.cfg) {
    return updateAdtCfg({ shopAdditionId: props.cfg.shopAdditionId, ...data })
  } else {
    return addAdtCfg(data)
  }
})

const [data, commit, clear] = useEdited(
  {
    adtMap,
    cateMap,
    cateList
  },
  () => {
    const additionList = Object.values(additionSort.value)
    if (props.forCate && !data.cateList.length) {
      return ElMessage.error(t('请至少选择一个配置类目'))
    }
    if ((!noNeed.value) && additionList.length === 0) {
      error.value = true
      return
    }
    api({
      additionList: noNeed.value ? [] : additionList.map((i: any) => {
        return {
          ...i,
          spotCheckFlag: i.spotCheckRatio && i.spotCheckFlag === 1 ? 1 : 0
        }
      }),
      additionScene: props.additionScene === 0 ? 0 : 1,
      categoryCodeList: data.cateList,
      noAdditionalFlag: noNeed.value ? 1 : 0,
      warehouseCode: getWarehouseCode(props.countryCode === COUNTRY.KR)
    }).then((res) => {
      if (res.success) {
        ElMessage.success(
          t(props.cfg ? '修改附加项模板成功' : '添加附加项模板成功')
        )
        clear()
        visible.value = false
        emit('update')
        emit('beforeClose')
      }
    })
  }
)
data.adtMap = refMap
const w = wrap(data.adtMap)
const changeAdt = (...rest: any) => {
  sortAdd(rest[0], rest[1])
  const [obj] = rest
  noNeed.value = false
  error.value = false
  w(...rest)
  adtRes.value.forEach((i: any) => {
    if (i.additionId === obj.additionId) {
      if (i.spotCheckSupport === 1) {
        i.spotCheckFlag = obj.spotCheckFlag
        i.spotCheckRatio = obj.spotCheckRatio
      }
    }
  })
}

additionSort.value = Object.values(data.adtMap)
const setdefault = async (items: any) => {
  noNeed.value = false
  const { adtMap } = data
  Object.keys(adtMap).forEach((k) => delete adtMap[k])
  items.forEach((v: any) => {
    adtRes.value.forEach((i: any) => {
      if (i.additionId === v.additionId) {
        if (i.spotCheckSupport === 1) {
          i.spotCheckFlag = v.spotCheckFlag
          i.spotCheckRatio = v.spotCheckRatio
        }

        // 适用附加项组合覆盖时不覆盖 additionConfigId
        adtMap[v.additionId] = i
      }
    })
  })
  additionSort.value = Object.values(adtMap)
  // 如果存在辅料的附加项则滚动到底部
  if (additionSort.value.filter((i: any) => i.ingredientStatus).length > 0) {
    scrollView()
  }
}

const updateCate = (val: number[]) => {
  data.cateList = val
}

const cancel = () => {
  confirm(
    () => (
      emit('beforeClose')
    ),
    () => { }
  )
}

const error = ref(false)
const noNeed = ref(!!(props.cfg?.noAdditionalFlag))
const handleNoNeed = () => {
  additionSort.value = []
  error.value = false
  Object.values(data.adtMap).forEach(v => {
    w(v, false)
  })
}

const confirmEdit = (close: any) => {
  confirm(() => {
    close && close()
  }, () => { })
}
expose({
  confirmEdit
})
clear()

// 是否选择辅料
const isMtrl = computed(() => {
  return Object.values(data.adtMap).filter((v: any) => v.ingredientStatus)?.length > 0
})

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          _createVNode(AdtTemplate, {
            type: "1",
            adt: adtRes.value,
            onSetdefault: setdefault,
            countryCode: __props.countryCode
          }, null, 8, ["adt", "countryCode"])
        ]),
        _: 1
      })),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [
            (__props.forCate)
              ? (_openBlock(), _createBlock(AdtCate, {
                  key: 0,
                  "has-map": _unref(hasMap),
                  "check-map": _unref(data).cateMap,
                  onUpdate: updateCate
                }, null, 8, ["has-map", "check-map"]))
              : (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(_unref(t)('全部类目')), 1))
          ]),
          _: 1
        })),
        _createVNode(AdtList, {
          onChange: _cache[1] || (_cache[1] = e => changeAdt(...e)),
          adt: adtRes.value,
          "adt-map": _unref(data).adtMap,
          choiceCost: __props.choiceCost
        }, {
          noNeedAddition: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_radio, {
                modelValue: noNeed.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((noNeed).value = $event)),
                label: true,
                style: {"font-weight":"600","margin-right":"0"},
                onChange: handleNoNeed
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('不需要检品')), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _withDirectives(_createElementVNode("div", { style: {"color":"#FF3C3C","font-size":"12px"} }, _toDisplayString(_unref(t)('附加项验证')), 513), [
                [_vShow, error.value]
              ])
            ])
          ]),
          _: 1
        }, 8, ["adt", "adt-map", "choiceCost"]),
        (_unref(isLogin) && __props.countryCode !== _unref(COUNTRY).KR)
          ? (_openBlock(), _createBlock(AdtMtrl, {
              key: 0,
              "adt-map": _unref(data).adtMap,
              sort: _unref(additionSort)
            }, null, 8, ["adt-map", "sort"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_unref(isMtrl) && __props.countryCode !== _unref(COUNTRY).KR)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", {
              innerHTML: _unref(t)('客户资材必须得提前先下好，保存在仓库，否则无法对应').split('\n').map(v => `<span>${v}</span>`).join('<br/>')
            }, null, 8, _hoisted_7)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_button, {
          type: "default",
          onClick: cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _unref(commit),
          loading: _unref(loading)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ])
    ])
  ], 64))
}
}

})